<template>
  <div>
    <v-container
      class="ma-0"
      fluid
    >
      <pageTitle>
        <template v-if="post.pid">Edit</template><template v-else>Add</template> Passion Shots
      </pageTitle>
      <blockTitle>
        <template v-if="post.pid">Edit your passion shots🧡</template>
        <template v-else>What's this passion about?🧡</template>
      </blockTitle>
      <blockContent>
        <SelectLikeSingle
          v-model="post.likeCode"
          :multiple="false"
        ></SelectLikeSingle>
      </blockContent>
      <blockTitle>
        <template v-if="post.pid">Edit</template><template v-else>Add</template> your passion shots📷
      </blockTitle>
      <blockContent>
        <v-row dense>
          <v-col
            v-for="item in post.photos"
            cols="4"
            sm="4"
            md="3"
            :key="item.id"
            class="pl-1"
          >
            <div
              class="frame-image"
            >
              <div
                class="delete-image"
                @click="deleteImage(item.id)"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3 0.709956C13.1131 0.522704 12.8595 0.417471 12.595 0.417471C12.3305 0.417471 12.0768 0.522704 11.89 0.709956L6.99997 5.58996L2.10997 0.699956C1.92314 0.512704 1.66949 0.407471 1.40497 0.407471C1.14045 0.407471 0.886802 0.512704 0.699971 0.699956C0.309971 1.08996 0.309971 1.71996 0.699971 2.10996L5.58997 6.99996L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40996L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99996L13.3 2.10996C13.68 1.72996 13.68 1.08996 13.3 0.709956Z" fill="#A4A2A2"/>
                </svg>
              </div>
              <img
                :src="item.squareUrl"
                style="width:100%"
                @click="doEdit(item)"
              />
            </div>
          </v-col>
          <v-col
            v-if="uploading"
            cols="4"
            sm="4"
            md="3"
          >
            <div
              class="d-flex justify-center align-center"
              style="width:100%;height:95%"
            >
              <v-progress-circular
                :width="3"
                color="#ff5500"
                indeterminate
              ></v-progress-circular>
            </div>
          </v-col>
          <v-col
            cols="4"
            sm="4"
            md="3"
            @click="showUploader"
          >
            <img
              :src="require('@/assets/images/shots/shots.svg')"
              style="width:100%"
            />
          </v-col>
        </v-row>
      </blockContent>
      <blockTitle>
        <template v-if="post.pid">Edit your passion description🖋</template>
        <template v-else>Tell us about your passion🖋</template>
      </blockTitle>
      <blockContent>
        <v-form
          ref="postForm"
        >
          <v-textarea
            outlined
            style="border-radius:8px"
            v-model="post.comment"
            readonly
            auto-grow
            rows="5"
            @click="showEditComment"
            @keyup="showEditComment"
          ></v-textarea>
        </v-form>
      </blockContent>
      <blockContent>
        <v-btn
          dark
          block
          color="#FF5500"
          style="border-radius: 8px"
          elevation="0"
          class="text-capitalize fz18 font-weight-bold"
          :disabled="process"
          :loading="process"
          @click.stop="doPost"
        >
          <template v-if="post.pid">Edit&Share</template>
          <template v-else>Share</template>
        </v-btn>
      </blockContent>
        <v-row
          class="ma-0"
          justify="center"
        >
          <v-btn
            v-if="post.pid"
            rounded
            small
            color="grey"
            class="text-capitalize mt-5"
            :disabled="process"
            :loading="process"
            @click.stop="dialogConfirmDelete = true"
          >
            Delete
          </v-btn>
        </v-row>

    </v-container>

    <editComment
      ref="editComment"
      v-model="post.comment"
    ></editComment>

    <crop
      ref="crop"
      @change="doEditEnd"
    ></crop>

    <input
      type="file"
      ref="fileSelect"
      class="d-none"
      @change="onFileChange"
      accept="image/png,image/jpeg"
      multiple
    />

    <v-snackbar
      v-model="snackbar.display"
      :timeout="10000"
    >
      {{ snackbar.text }}
      <v-btn
        text
        @click="snackbar.display = false"
      >Close</v-btn>
    </v-snackbar>

    <v-dialog
      persistent
      v-model="dialogConfirm"
      transition="dialog-bottom-transition"
      content-class="v-dialog-form-bottom"
    >
      <v-card flat style="100%">
        <v-card-title
          class="py-3 mb-6 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <div style="width:28px"></div>
          <span class="font-weight-bold">Tips✨</span>
          <v-btn
            icon
            small
            @click="dialogConfirm = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          Share your passion here to make it easier to find new friends😊
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="$router.push(nextRoute)"
          >
            Skip
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogConfirm = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogConfirmDelete"
      transition="dialog-bottom-transition"
      content-class="v-dialog-form-bottom"
    >
      <v-card flat style="100%">
        <v-card-title
          class="py-3 mb-6 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <div style="width:28px"></div>
          <span class="font-weight-bold">Confirmation😊</span>
          <v-btn
            icon
            small
            @click="dialogConfirmDelete = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          Are you sure to delete this page?
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn
            text
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="doDelete"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <messageBox
      ref="msgBox"
    ></messageBox>

    <bottomNavigation
      activeNav="favorite"
      :changeRoute="false"
      @change="changeNavigation"
    ></bottomNavigation>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import "firebase/firestore"
import service from '@/plugins/service'
import BottomNavigation from '@/components/Like/BottomNavigation'
import Crop from '@/components/Like/Crop'
import SelectLikeSingle from '@/components/Like/SelectLikeSingle'
import EditComment from '@/components/Like/EditComment'
import pageTitle from '@/components/Like/PageTitle'
import blockTitle from '@/components/Like/BlockTitle'
import blockContent from '@/components/Like/BlockContent'
import messageBox from '@/components/MessageBox'

export default {
  components: {
    BottomNavigation,
    Crop,
    SelectLikeSingle,
    EditComment,
    pageTitle,
    blockTitle,
    blockContent,
    messageBox,
  },
  data: () => ({
    user: {
      uid: ''
    },
    dialogConfirm: false,
    dialogConfirmDelete: false,
    nextRoute: '',
    process: false,
    uploading: false,
    snackbar: {
      display: false,
      text: '',
    },
    post: {
      pid: '',
      like: '',
      likeCode: '',
      comment: '',
      mainPhotoId: -1,
      photos: [],
    },
  }),
  async mounted() {
    // ログインチェック
    try {
      this.user = await service.authCheck()
    } catch (e) {
      this.$router.replace('/signIn/post/new')
      return
    }
    // Profileが完成しているかどうか確認
    const isProfileComplete = await service.isProfileComplete(this.user.uid)
    if (!isProfileComplete) {
      this.$refs.msgBox.show(
        'Oops!',
        'Make sure all the required items are filled out🙏',
        'OK',
        () => {
          this.setNextRoute(`/post`)
          this.$router.push('/myProfile')
        }
      )
      return
    }
    const pid = this.$route.params.pid
    if (pid && pid != 'new') {
      this.post.pid = pid
      // 既存情報を取得する
      const json = await service.getPostDetail(this.user.uid, pid)
      const data = json.res
      this.post.comment = data.comment
      this.post.likeCode = data.likeCode
      this.post.mainPhotoId = data.mainPhotoId
      data.photos.forEach(item => this.post.photos.push(item))
    }
  },
  methods: {
    ...mapActions('storage', [
      'setNextRoute',
    ]),
    showUploader() {
      this.$refs.fileSelect.click()
      // this.$refs.uploader.show()
    },
    async doPost() {
      const user = firebase.auth().currentUser
      if (!user) {
        this.$router.replace('/signIn/post')
        return
      }
      this.process = true
      try {
        // ライクを選択されているかどうか
        if (!this.post.likeCode) {
          this.$refs.msgBox.show(
            'Oops!',
            'Please choose the category!😊',
            'OK',
          )
          return
        }
        // ファイルを登録しているかどうか
        if (this.post.photos.length < 1) {
          this.$refs.msgBox.show(
            'Oops!',
            'Please upload a photo!😊',
            'OK',
          )
          return
        }
        const uid = user.uid
        let pid = this.post.pid
        if (!pid) {
          // pid(PostID)が存在しない場合は、生成する。
          // [uid + タイムスタンプ]
          pid = `${uid}_${new Date().getTime()}`
        }
        let mainPhotoId = this.post.mainPhotoId
        let mainPhotoUrl = ''
        const photoUrls = []
        this.post.photos.forEach(item => {
          if (mainPhotoId < 0) {
            mainPhotoId = item.id
          }
          if (item.id == mainPhotoId) {
            mainPhotoUrl = item.squareUrl
            photoUrls.unshift(item.squareUrl)
          } else {
            photoUrls.push(item.squareUrl)
          }
        })
        // 検索システムに全ての情報を登録
        await service.post(uid, pid, this.post.likeCode, mainPhotoId, mainPhotoUrl, this.post.photos, this.post.comment)
        this.snackbar.text = 'Register completed.'
        this.snackbar.display = true
        this.$router.push(`/likeDetail/${pid}`)
      } catch (e) {
        this.snackbar.text = 'Register failed.'
        this.snackbar.display = true
        service.log(e)
      } finally {
        this.process = false
      }
    },
    async onFileChange(e) {
      // 一括選択されたファイルをサーバに格納する
      this.process = true
      this.uploading = true
      try {
        const files = e.target.files || e.dataTransfer.files
        const result = await service.postNewPhoto(this.user.uid, files)
        result.res.forEach(item => {
          this.post.photos.push(item)
        })
        this.$refs.fileSelect.value = ''
      } finally {
        this.uploading = false
        this.process = false
      }
    },
    doEdit(item) {
      this.$refs.crop.show(this.user.uid, item.id, this.post.mainPhotoId == item.id, item.orgUrl)
    },
    doEditEnd(dat) {
      if (dat.isCover) {
        this.post.mainPhotoId = dat.id
      } else {
        if (this.post.mainPhotoId == dat.id) {
          this.post.mainPhotoId = -1;
        }
      }
      this.post.photos.forEach(item => {
        if (item.id == dat.id) {
          item.square = dat.square
          item.squareUrl = dat.squareUrl
          item.thumbnail = dat.thumbnail
          item.thumbnailUrl = dat.thumbnailUrl
        }
      })
    },
    async doDelete() {
      try {
        this.process = true
        // docを削除する
        const user = firebase.auth().currentUser
        // 検索システムの情報を削除する
        await service.postDelete(user.uid, this.post.pid)
        this.snackbar.text = 'Delete completed.'
        this.$router.push('/likes')
      } catch (e) {
        service.log(e)
        this.snackbar.text = 'Delete failed.'
      } finally {
        this.snackbar.display = true
        this.process = false
      }
    },
    showEditComment() {
      this.$refs.editComment.show('likeComment')
    },
    async changeNavigation(route) {
      const json = await service.getUserLikes(this.user.uid)
      if (json.res.length <= 0) {
        this.nextRoute = route
        this.dialogConfirm = true
      } else {
        this.$router.push(route)
      }
    },
    /** 画像削除ボタンクリックにより画像を削除する */
    deleteImage(id) {
      if (this.post.mainPhotoId == id) {
        this.post.mainPhotoId = -1
      }
      const photos = this.post.photos
      for (let i = 0 ; i < photos.length ; i++) {
        if (photos[i].id == id) {
           photos.splice(i, 1)
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
div.frame-image
  position relative
  width 100%
  img
    border-radius 8px
    display block
div.delete-image
  position absolute
  top 1px
  right 1px
</style>
